import {
  Output,
  OnInit,
  OnDestroy,
  Component,
  ViewChild,
  EventEmitter,
  ChangeDetectorRef
} from '@angular/core'
import { FormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { zip } from 'rxjs'

import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { DialogModule } from 'primeng/dialog'
import { ButtonModule } from 'primeng/button'
import { MessageService } from 'primeng/api'

import {
  EntityInterfaces,
  BackendService,
  BuilderFields,
  FieldConfig
} from '@peritos/api-client'
import {
  FormPrepareService,
  peritosFormModule,
  FormComponent
} from '@peritos/form-builder'

import { pacientesFieldConfig } from 'src/app/pages/home/pacientes/pacientes-fields'
import { GridCrudComponent } from './../grid-crud/grid-crud.component'

@Component({
  selector: 'app-patient-dialog',
  templateUrl: './patient-dialog.component.html',
  styleUrls: ['./patient-dialog.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    DialogModule,
    ButtonModule,
    peritosFormModule,
    GridCrudComponent,
    ProgressSpinnerModule
  ]
})
export class PatientDialogComponent implements OnInit, OnDestroy {
  @Output() destroy: EventEmitter<void> = new EventEmitter()
  @Output() afterSave: EventEmitter<EntityInterfaces['pacientes']['get']> =
    new EventEmitter()

  @ViewChild('patientForm') patientForm!: FormComponent<'pacientes'>

  visible = true
  loading = false
  saving = false

  idPaciente!: number
  paciente!: EntityInterfaces['pacientes']['get']
  pacienteDirecciones: EntityInterfaces['pac_direcciones']['get'][] = []
  pacienteTelefonos: EntityInterfaces['pac_telefonos']['get'][] = []
  pacienteEmails: EntityInterfaces['pac_emails']['get'][] = []

  pacienteModel: BuilderFields[] = []
  pacDireccionesModel: BuilderFields[] = []
  pacTelefonosModel: BuilderFields[] = []
  pacEmailsModel: BuilderFields[] = []

  activeTab = 0

  fieldConfig: FieldConfig<'pacientes'> = pacientesFieldConfig

  constructor(
    private backendService: BackendService,
    private prepareForm: FormPrepareService,
    private cdr: ChangeDetectorRef,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    if (!this.idPaciente) return
    this.loading = true
    zip(
      this.backendService.get('builder', {
        filter: [
          {
            field: 'table_name_parent',
            operator: 'in',
            value: [
              'pacientes',
              'pac_direcciones',
              'pac_telefonos',
              'pac_emails'
            ]
          }
        ],
        no_limit: true
      }),
      this.backendService.getByIdOrLoad('pacientes', this.idPaciente)
    ).subscribe(([model, paciente]) => {
      this.paciente = paciente
      this.pacienteModel = model.filter(
        (field) => field.table_name_parent === 'pacientes'
      )
      this.pacDireccionesModel = model.filter(
        (field) => field.table_name_parent === 'pac_direcciones'
      )
      this.pacTelefonosModel = model.filter(
        (field) => field.table_name_parent === 'pac_telefonos'
      )
      this.pacEmailsModel = model.filter(
        (field) => field.table_name_parent === 'pac_emails'
      )
      this.loading = false
      this.cdr.detectChanges()
    })
  }

  save() {
    if (!this.patientForm) return
    const form = this.patientForm.form
    if (form.invalid) {
      form.markAllAsTouched()
      return
    }
    this.saving = true
    const data = {
      ...form.value,
      id: this.idPaciente
    }
    const model = this.prepareForm.prepareData(
      'pacientes',
      this.pacienteModel,
      data
    )
    this.backendService
      .put('pacientes', model as EntityInterfaces['pacientes']['put'])
      .subscribe({
        next: (res) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Éxito',
            detail: 'Los datos se han actualizado correctamente'
          })
          this.afterSave.emit(res)
          this.saving = false
          this.cdr.detectChanges()
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error ?? 'Ha ocurrido un error al actualizar los datos'
          })
          this.saving = false
          this.cdr.detectChanges()
        }
      })
  }

  goToPatient() {
    window.open(`/directorio/pacientes/${this.idPaciente}`, '_blank')
  }

  onDestroy() {
    this.destroy.emit()
  }

  ngOnDestroy(): void {
    this.onDestroy()
  }
}
